import { Components, Theme } from '@mui/material/styles';
import { FlowDialogTitle } from './DialogTitle';

export const flowDialogTitle: Components<Theme>['MuiDialogTitle'] = {
  defaultProps: {
    variant: 'h3',
    component: FlowDialogTitle,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      minWidth: '0',
      flexShrink: '1',
      flexGrow: '1',
      padding: '24px 40px 8px',
      [theme.breakpoints.down('md')]: {
        paddingLeft: '24px',
        paddingRight: '24px',
      },
    }),
  },
};
